import { Routes, Route } from 'react-router-dom';

import { DashboardLayout } from '@/layouts/DashboardLayout';
import { AuthLayout } from '@/layouts/AuthLayout';
import { ProtectedRoute } from '@/components/common/ProtectedRoute';
import { AdminRoute } from '@/components/common/AdminRoute';

import { LoginPage } from '@/pages/auth/LoginPage';
import { DashboardPage } from '@/pages/dashboard/DashboardPage';
import { UsersPage } from '@/pages/users/UsersPage';
import { ChangePasswordPage } from '@/pages/auth/ChangePasswordPage';
import { JoinRequestsPage } from '@/pages/community/JoinRequestsPage';
import { SessionsPage } from '@/pages/sessions/SessionsPage';
import { CreateSessionPage } from '@/pages/sessions/CreateSessionPage';
import { EditSessionPage } from '@/pages/sessions/EditSessionPage';
import { TrashPage } from '@/pages/sessions/TrashPage';
import { NotFoundPage } from '@/pages/NotFoundPage';
import { NewsPage } from '@/pages/news/NewsPage';
import { EventsPage } from '@/pages/events/EventsPage';
import { EventJoinRequestsPage } from '@/pages/events/EventJoinRequestsPage';

import VerifyTicketPage from '@/pages/events/VerifyTicketPage';

export function App() {
  return (
    <Routes>
      {/* Auth Routes */}
      <Route element={<AuthLayout />}>
        <Route path="/login" element={<LoginPage />} />
      </Route>

      {/* Protected Routes */}
      <Route element={<ProtectedRoute />}>
        <Route element={<DashboardLayout />}>
          <Route path="/" element={<DashboardPage />} />
          <Route path="/dashboard" element={<DashboardPage />} />
          {/* Security Routes */}
          <Route path="/change-password" element={<ChangePasswordPage />} />

          {/* Community Routes */}
          <Route path="/community/requests" element={<JoinRequestsPage />} />

          {/* Sessions Routes */}
          <Route path="/sessions" element={<SessionsPage />} />
          <Route path="/sessions/create" element={<CreateSessionPage />} />
          <Route path="/sessions/:id/edit" element={<EditSessionPage />} />
          <Route path="/sessions/trash" element={<TrashPage />} />

          {/* News Routes */}
          <Route path="/news" element={<NewsPage />} />

          {/* Events Routes */}
          <Route path="/events" element={<EventsPage />} />
          <Route path="/events/join-requests" element={<EventJoinRequestsPage />} />
          <Route path="/events/verify" element={<VerifyTicketPage />} />

          {/* Admin Routes */}
          <Route element={<AdminRoute />}>
            <Route path="/users" element={<UsersPage />} />
          </Route>
        </Route>
      </Route>

      {/* 404 */}
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
